import { AppServiceToken } from '../models/app.service.model';
import { CompanyToken } from '../models/company.model';
import { Token, TokenSwitch, TokenRefresh, TokenSettings } from '../models/token.model';
import { UserToken } from '../models/user.model';
import { getCookie, getCookies, removeCookies, setCookies } from './cookies.script';

function normalizeCompany(companies: CompanyToken[] | null | undefined): CompanyToken[] | null {
  if (companies || Array.isArray(companies)) {
    return companies.map((item) => ({...item, logo: item.logo && item.logo.startsWith('data:') ? '' : item.logo}))
  } else {
    return null
  }
}

export function authLogin(token: Token) {
  const companiesValue = normalizeCompany(token.companies) ?? []
  console.log('[WRITE authLogin] token.companies=', token.companies, '| normalized=', companiesValue, '| isArray=', Array.isArray(companiesValue), '| length=', companiesValue?.length)
  setCookies({
    'access': token.access_token,
    'refresh': token.refresh_token,
    'expiry': Date.now() + token.expires_in * 1000,
    'user': token.user,
    'service': token.app_service || null,
    'company': token.company || null,
    'companies': companiesValue
  })
  console.log('[WRITE authLogin] relecture getCookie("companies")=', getCookie('companies'), '| document.cookie=', document.cookie.substring(0, 300))

  // Seed subscription snapshot to sessionStorage so SubscriptionProvider
  // picks it up immediately on mount — avoids an extra API round-trip.
  // Never in cookies: this is display data, not auth data.
  if (token.subscription) {
    try { sessionStorage.setItem('da_subscription_snapshot', JSON.stringify(token.subscription)) } catch {}
  }
}

export function authRefreshToken(token: TokenRefresh) {
  setCookies({
    'access': token.access_token,
    'refresh': token.refresh_token,
    'expiry': Date.now() + token.expires_in * 1000
  })
}

export function authSwitchCompany(token: TokenSwitch) {
  setCookies({
    'access': token.access_token,
    'refresh': token.refresh_token,
    'expiry': Date.now() + token.expires_in * 1000,
    'company': token.company || null,
    'companies': normalizeCompany(token.companies) ?? []
  })
}

export function authInvitationCompany(token: TokenSwitch) {
  setCookies({
    'access': token.access_token,
    'refresh': token.refresh_token,
    'expiry': Date.now() + token.expires_in * 1000,
    'company': token.company || null,
    'companies': normalizeCompany(token.companies) ?? []
  })
}

export function authCompanySettings(token: TokenSettings) {
  setCookies({
    'access': token.access_token,
    'refresh': token.refresh_token,
    'expiry': Date.now() + token.expires_in * 1000,
    'company': token.company || null,
    'companies': normalizeCompany(token.companies) ?? []
  })
}

export function authLogout() {
  removeCookies(['access', 'refresh', 'expiry', 'service', 'company', 'companies'])
}

export function authClear() {
  removeCookies(['access', 'refresh', 'expiry', 'user', 'service', 'company', 'companies'])
}

export function authController(): boolean {
  let cookies: any = getCookies(['access', 'refresh', 'expiry', 'user'])
  return Object.values(cookies).every(value => !!value)
}

export function authClosed(): boolean {
  let cookies: any = getCookies()
  return Object.entries(cookies).every(([key, value]) => (key === 'user' ? !!value : !value))
}

export function authExpired(): boolean {
  let user: any = getCookie('user')
  let expiry: number = Number(getCookie('expiry'))
  let expired: boolean = !!user && Date.now() > expiry

  if (expired) {
    removeCookies(['access', 'refresh', 'expiry', 'user', 'service', 'company', 'companies'])
  }

  return expired
}

export function authToken(): string {
  let token: any = getCookie('access')
  return token ? `Bearer ${token}` : ''
}

export function authRefresh(): string {
  let token: any = getCookie('refresh')
  return token ?? ''
}

export function authMultiCompany(): boolean {
  let companies: any = getCookie('companies')
  let company: any = getCookie('company')
  const hasCompanies = Array.isArray(companies) && companies.length > 0
  const hasCurrentCompany = !!company && company !== 'null' && typeof company === 'object' && !!company.id
  const result = hasCompanies || hasCurrentCompany
  console.log('[authMultiCompany] companies=', companies, '| company=', company, '| hasCompanies=', hasCompanies, '| hasCurrentCompany=', hasCurrentCompany, '| result=', result)
  return result
}

export function authApiKey(): string {
  let service: any = getCookie('service')
  return (service && service !== 'null') ? service.api_key ?? '' : process.env.REACT_APP_SERVICE_API_KEY ?? ''
}

export function authEmail(): string {
  let user: any = getCookie('user')
  return (user && user !== 'null') ? user.email ?? '' : ''
}

export function authUser(): UserToken | null {
  let user: any = getCookie('user')
  return (user && user !== 'null') ? user : null
}

export function authService(): AppServiceToken | null {
  let service: any = getCookie('service')
  return (service && service !== 'null') ? service : null
}

export function authCompany(): CompanyToken | null {
  let company: any = getCookie('company')
  return (company && company !== 'null') ? company : null
}

export function authCompanies(): CompanyToken[] {
  let companies: any = getCookie('companies')
  return (companies && companies !== 'null') ? Array.isArray(companies) ? companies : [] : []
}
